

























































































































import { ConfirmModalState, WithMultipleConfirmModal } from '@/components/organisms/confirm-modal/with-multiple-confirm-modal'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { log } from '@/log'
import CrossPageTransition from '@/mixin/cross-page-transition'
import { ApiCreditcard } from '@/models/api/creditcard'
import {
  AvailablePaidMembershipPlanInGroup
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group'
import {
  DefaultAvailableMembershipPlanGroupRepository,
  ListAvailablePaidMembershipPlanGroupRepository,
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group-repository'
import {
  stringifyErrorForEndUser,
  SubscribePaidMembershipPlanError,
} from '@/models/paid-membership/subscribe/errors'
import {
  WithSubscribePaidMembershipPlanProcess
} from '@/models/paid-membership/subscribe/with-subscribe-paid-membership-plan-process'
// @ts-ignore
import { ActionRequest } from '@/models/payment/creditcard/action/action' // ts3.8以降であればimport typeが利用可能
import { WithCreditcardForSubscriptionRepository } from '@/models/payment/creditcard/context/for-subscription/mixin'
import { changeCreditcardForSubscription } from '@/models/payment/creditcard/context/for-subscription/service/change-creditcard'
import {
  CreditcardRegistrationDependencies,
  registerNewCreditcard,
} from '@/models/payment/creditcard/service/register-new-creditcard'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
// @ts-ignore
import ItemRequestResultModal from '@ajax/vue/components/templates/item-detail/ItemRequestResultModal.vue'
import Step from '@spa/components/atoms/Step.vue'
import TitleSection from '@spa/components/atoms/TitleSection.vue'
import { ExtraProfileFormState } from '@spa/components/organisms/paid-membership/creditcard-extra-profile/ExtraProfile.vue'
import NewCreditcard, { RegisterCreditcardEmit } from '@spa/components/organisms/paid-membership/NewCreditcard.vue'
import NotFoundPlanSubscribableNewly from '@spa/components/organisms/paid-membership/NotFoundPlanSubscribableNewly.vue'
import SelectPaidMemberPlan from '@spa/components/organisms/paid-membership/SelectPaidMemberPlan.vue'
import ShowCreditcard from '@spa/components/organisms/paid-membership/ShowCreditcard.vue'
import SpaCreditCardDescription from '@spa/components/organisms/payment/description/CreditCardDescription.vue'
import PaidMembershipPlanNote from '@spa/components/pages/paid-membership/subscribe/components/note/PaidMembershipPlanNote.vue'

import { Context } from '@spa/components/pages/paid-membership/subscribe/interaction/context'
import {
  PaidMembershipSubscribeInteraction,
} from '@spa/components/pages/paid-membership/subscribe/interaction/interaction'
import { noteState } from '@spa/components/pages/paid-membership/subscribe/interaction/view-state/note/note-state'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CallbackErrorMessageParse, ThreeDSecureResultPageMixin } from '@spa/mixins/three-d-secure-result-page'
import { User } from '@spa/store/modules/user/types'
import { some } from 'fp-ts/lib/Option'
import _ from 'lodash'
import { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

Component.registerHooks([
  'beforeRouteEnter',
])

type MixedIn = PluginMixin
  & CrossPageTransition
  & ThreeDSecureResultPageMixin
  & WithCreditcardForSubscriptionRepository
  & WithMultipleConfirmModal
  & WithSubscribePaidMembershipPlanProcess

@Component({
  components: {
    ConfirmModal,
    Step,
    TitleSection,
    PaidMembershipPlanNote,
    NotFoundPlanSubscribableNewly,
    SpaErrorDialog,
    SpaCreditCardDescription,
    ShowCreditcard,
    NewCreditcard,
    SelectPaidMemberPlan,
  },
  mixins: [
    LoadingMixin,
    ThreeDSecureResultPageMixin,
    WithMultipleConfirmModal,
  ],
})
export default class SubscribePaidMembership extends
  Mixins<MixedIn>(
    PluginMixin,
    CrossPageTransition,
    ThreeDSecureResultPageMixin,
    WithCreditcardForSubscriptionRepository,
    WithMultipleConfirmModal,
    WithSubscribePaidMembershipPlanProcess
  ) {

  /**
   * カード登録に関する通知系・成功系のモーダルとしてConfirmModalを使っている。
   * デザインは ItemRequestResultModal を参考にしているが、汎用的なモーダルが用意され次第そちらに統合する。
   * @see ConfirmModal
   * @see ItemRequestResultModal
   */

  @Prop({ required: true })
  readonly title: string

  @Prop({ required: true })
  readonly context: Context

  @Prop({ required: true })
  readonly creditcardRegistrationDependencies: CreditcardRegistrationDependencies

  status: Status = Status.Pending
  initializeStatus: 'not-initialized' | 'initialized' = 'not-initialized'
  showModal: boolean = false
  modalMessage: string = ''
  multipleConfirmModalState: ConfirmModalState[] = [
    ConfirmModalState.initial(ConfirmModalKey.BeforeRegister),
    ConfirmModalState.initial(ConfirmModalKey.RegisterSuccess),
  ]

  private interaction: PaidMembershipSubscribeInteraction = PaidMembershipSubscribeInteraction.empty()

  get initialStep(): number {
    return this.context.currentStep
  }

  async created() {
    this.status = Status.Loading

    try {
      await this.initUser()
      await this.setUpInteraction()

      this.status = Status.Completed
      this.initializeStatus = 'initialized'

      this.handleThreeDSecureCallbackSuccess()
      this.handleThreeDSecureCallbackError()
    } catch (e) {
      this.handleError(e)
    }
  }

  get note(): VueConstructor {
    return noteState(this.interaction)
  }

  get _selectedCreditcard(): ApiCreditcard | null {
    return this.interaction.selectedCreditCard.fold(null, card => card)
  }

  /**
   * 有料会員登録時はユーザー情報のみ vuex を利用し、それ以外のデータは vuex を利用していない。
   * これは以下の理由による。
   * - 有料会員登録ステップを１画面で完結できるため、画面を跨いでデータを保持する必要がない
   * - 有料会員登録時に扱うデータと商品購入時に扱うデータが大きく異なる
   */
  get user(): User {
    return this.$store.state.user.user
  }

  get planGroupRepository(): ListAvailablePaidMembershipPlanGroupRepository {
    return DefaultAvailableMembershipPlanGroupRepository.forHost
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get isPageInitialized() {
    return this.initializeStatus === 'initialized'
  }

  get shouldShowSelectPlanView(): boolean {
    return this.interaction.isSelectPlan || this.interaction.isCompleted()
  }

  async wilReplaceCreditCard() {
    this.interaction.willReplaceByNewCreditCard()
  }

  get headingIconUrl(): string {
    return '/assets-proxy/images/common/icon/exclamation.svg'
  }

  get confirmModalKeys(): typeof ConfirmModalKey {
    return ConfirmModalKey
  }

  get defaultExtraProfileFormState(): ExtraProfileFormState {
    return {
      buyerNameKanji: `${this.user.last_name || ''}${this.user.first_name || ''}`,
      buyerEmail: this.user.email || '',
      buyerTel: this.user.tel || '',
    }
  }

  onSelectCreditcardAlreadyRegistered() {
    this.interaction.selectedCreditCard.foldL(
      () => {
        this.modalMessage = 'クレジットカードが登録されていません'
        this.showModal = true
      },
      (cardAlreadySelected: ApiCreditcard) => {
        this.interaction.changeCreditCard(cardAlreadySelected)
      }
    )
  }

  async initUser(): Promise<void> {
    await this.$store.dispatch('user/get')

    const errorOnGet = _.get(this.$store.state.user, 'error.get')
    if (errorOnGet || !this.user || this.user.user_status !== 'registered') {
      throw new Error('registered user is required on paid membership subscribe page')
    }
  }

  async setUpInteraction() {
    const result = await this.creditCardForSubscriptionRepository.findRegistered()
    result.map((card) => {
      this.interaction = PaidMembershipSubscribeInteraction.initializeWithCreditCard(card)
    })

    this.interaction.onStepChange('select-plan', async () => {
      this.status = Status.Loading
      /**
       * 「グループごとに区切り線を表示する」などの追加対応も必要かもしれない.
       * ledian v1 では1グループしか扱わないのと、リリースまでの期日(2022/3/1)との兼ね合いから、
       * 一旦既存の構造をなるべく変えない形で対応.
       * @see https://github.com/my-color/front/issues/6130
       */
      await this.planGroupRepository.listAvailables().then((groups) => {
        this.interaction.setAvailablePlans(
          groups
            .reduce<AvailablePaidMembershipPlanInGroup[]>((xs, g) => xs.concat(g.plans), [])
            .filter(p => p.canSubscirbeAsNew)
        )
      })
      this.status = Status.Pending
    })
  }

  async registerCreditcard({ creditcardFormState, extraProfileFormState }: RegisterCreditcardEmit) {
    await this.confirm(ConfirmModalKey.BeforeRegister)
      .then((confirmed) => {
        if (!confirmed) return // キャンセルボタンなしで運用しているため、ここが発火することはない想定
        this.removeTheeDSecureResultQueryParams()
      })

    this.status = Status.Loading

    try {
      /**
       * 戻り値がPromise<void>であるように、登録・変更結果を直接受け取ってはいない。
       * 3Dセキュアでのリダイレクトのように結果を受け取るためには再びGPの画面を描写すればいい場合は問題にならないが、
       * それ以外にも結果に基づいてこのメソッドから何らかの処理を指示したい場合は、ここに後続処理を記述するのではなく、フックを注入すること。
       * @see ActionRequest
       */
      await this.interaction.selectedCreditCard.foldL(
        () => registerNewCreditcard(this.creditcardRegistrationDependencies, creditcardFormState, this.user, {
          enableSubProcess: true,
          threeDSecureRedirectUrl: some(new URL(
            this.$router.resolve({ path: '/paid-membership/subscribe' }).href,
            window.location.origin
          )),
          threeDSecureExtraProfile: some(extraProfileFormState),
        }),
        oldCard => changeCreditcardForSubscription(
          this.creditCardForSubscriptionRepository,
          {
            creditcard: {
              oldCard,
              newCard: creditcardFormState,
            },
          },
          this.user,
          {
            enableSubProcess: true,
            threeDSecureRedirectUrl: some(new URL(
              this.$router.resolve({ path: '/paid-membership/subscribe' }).href,
              window.location.origin
            )),
            threeDSecureExtraProfile: some(extraProfileFormState),
          }
        )
      )

      // 正常に画面リダイレクトが発生した場合は到達しない
      this.status = Status.Completed
    } catch (e) {
      this.handleError(e)
    }
  }

  async subscribePaidMember() {
    try {
      if (this.interaction.isCompleted()) {
        this.status = Status.Loading

        await this.subscribePaidMembershipPlan({
          payment: await this.interaction.providePaymentPayloadFor(this.user),
          plan: {
            external_id: this.interaction.selectedPlan.value,
          },
        })

        /**
         * キャッシュ破棄
         * @see https://github.com/my-color/front/issues/6328#issuecomment-1099649686
         */
        await this.$store.dispatch('user/unload')

        this.goToCompletePage()

        this.status = Status.Completed

      } else {
        const modalMessage = [
          this.interaction.selectedCreditCard.fold('', () => 'クレジットカードが選択されていません'),
          this.interaction.selectedPlan.fold('', () => 'プランが選択されていません'),
        ].join('<br>')

        throw new SubscribePaidMembershipPlanError(
          'interaction state must be completed',
          modalMessage
        )
      }
    } catch (e) {
      this.handleError(e)
    }
  }

  onInputPlan(planId: string) {
    this.interaction.selectPlan(planId)
  }

  goToCompletePage() {
    this.$router.push({
      path: '/paid-membership/subscribe/complete',

      // 有料会員登録ページアクセス時のクエリをそのまま引き継ぐ
      query: this.$route.query,
    })
  }

  handleErrorDialogClose() {
    this.showModal = false
    this.removeTheeDSecureResultQueryParams()
  }

  /**
   * @override
   * @protected
   * @see WithSubscribePaidMembershipPlanProcess.brandEnglishName
   */
  protected brandEnglishName(): string {
    return BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
  }

  private handleError(e) {
    log.error(e)

    this.modalMessage = stringifyErrorForEndUser(e)
    this.showModal = true
    this.status = Status.Failed
  }

  private handleThreeDSecureCallbackSuccess(): void {
    if (!this.threeDSecureCallbackSuccess) return

    this.confirm(ConfirmModalKey.RegisterSuccess).then((_confirmed) => {
      this.removeTheeDSecureResultQueryParams()
    })
  }

  private handleThreeDSecureCallbackError(): void {
    const message = new CallbackErrorMessageParse().parse(
      this.threeDSecureCallbackErrorType,
      this.threeDSecureCallbackErrorCode,
      this.threeDSecureCallbackErrorCredit,
      this.threeDSecureCallbackErrorMessage
    )

    if (message === null) return

    this.modalMessage = message
    this.showModal = true
    this.status = Status.Failed
  }
}

enum ConfirmModalKey {
  BeforeRegister = 'before-register',
  RegisterSuccess = 'register-success',
}
